// extracted by mini-css-extract-plugin
module.exports = {"charCounter":"AdacIncidentTypePage_charCounter__4K7hs"};